import React, { useEffect, memo } from "react";
import { Helmet } from "react-helmet";
import { useSelector, useDispatch } from "react-redux";
import Button from "@material-ui/core/Button";
import AddTicketTypeDialog from "./components/AddTicketTypeDialog";
import TicketTypeListTable from "./components/TicketTypeTable";
import { useStyles } from "./styles";
import { SvgIconAdd, SvgLoaderGif } from "../../components/NeIcons";
import Loader from "../../components/Loader";
import { getTicketTypesList } from "./actions";
import { useInjectReducer } from "../../utils/injectReducer";
import { useInjectSaga } from "../../utils/injectSaga";
import reducer from "./reducer";
import saga from "./saga";
import { createStructuredSelector } from "reselect";
import { selectCustomerSupport } from "./selectors";

const stateSelector = createStructuredSelector({
  customerSupport: selectCustomerSupport,
});

function CustomerSupport() {
  useInjectReducer({ key: "customerSupport", reducer });
  useInjectSaga({ key: "customerSupport", saga });

  const { customerSupport }: any = useSelector(stateSelector);
  const { customerSupportList, isLoading } = customerSupport;

  const dispatch = useDispatch();
  const classes = useStyles();
  const [state, setState] = React.useState({
    isAddClick: false,
  });

  useEffect(() => {
    dispatch(getTicketTypesList());
  }, []);

  const openAddTicketTypeDialog = () => {
    setState({ ...state, isAddClick: true });
  };

  const closeAddDialog = () => {
    setState({ ...state, isAddClick: false });
  };

  return (
    <>
      <Helmet>
        <title>Customer Support</title>
        <meta name="description" content="Add tags for Customer Support." />
      </Helmet>
      {isLoading && <Loader />}

      <div className={classes.root}>
        <div>
          <div className={classes.headWrap}>
            <div className={classes.head}>Configure: Customer Support</div>
            <div className={classes.searchWrap}></div>
          </div>
          <div className={classes.headWrap}>
            <Button
              onClick={() => {
                openAddTicketTypeDialog();
              }}
              variant="contained"
              color="secondary"
              className={classes.addCustomerSupportBtn}
              disableRipple={true}
            >
              <SvgIconAdd />{" "}
              <div className={classes.newCustomerSupport}>TICKET TYPES</div>
            </Button>
          </div>

          {!customerSupportList ||
          (customerSupportList && customerSupportList.length === 0) ? (
            isLoading ? (
              <div style={{ padding: "10px" }}>
                <SvgLoaderGif />
              </div>
            ) : isLoading || customerSupportList === null ? (
              <div style={{ padding: "10px" }}>
                <SvgLoaderGif />
              </div>
            ) : (
              <div className={classes.noData}>No Data Found</div>
            )
          ) : (
            <TicketTypeListTable
              list={customerSupportList}
              classes={classes}
              isLoading={isLoading}
            />
          )}
        </div>
      </div>
      {state.isAddClick && (
        <AddTicketTypeDialog
          classes={classes}
          isOpen={state.isAddClick}
          closeAddDialog={closeAddDialog}
        />
      )}
    </>
  );
}

export default memo(CustomerSupport);
